const STORAGE_KEY = "mcm_technical_issues";
const LEGACY_STORAGE_KEY = "mcm_bug_reports";

function getAll() {
  try {
    let data = localStorage.getItem(STORAGE_KEY);
    if (!data) {
      const legacy = localStorage.getItem(LEGACY_STORAGE_KEY);
      if (legacy) {
        localStorage.setItem(STORAGE_KEY, legacy);
        localStorage.removeItem(LEGACY_STORAGE_KEY);
        data = legacy;
      }
    }
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
}

function saveAll(reports) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(reports));
}

/**
 * Obtiene todos los reportes ordenados por fecha descendente.
 * @returns {Array} Lista de reportes
 */
export function getReports() {
  const reports = getAll();
  return reports.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
}

/**
 * Crea un nuevo technical issue.
 * @param {Object} report - Datos del reporte
 * @returns {Object} Reporte creado con id, createdAt y status
 */
export function createReport(report) {
  const reports = getAll();
  const newReport = {
    ...report,
    id: Date.now(),
    createdAt: new Date().toISOString(),
    status: "open",
  };
  reports.push(newReport);
  saveAll(reports);
  return newReport;
}

/**
 * Actualiza un reporte existente.
 * @param {number} id - ID del reporte
 * @param {Object} updates - Campos a actualizar
 * @returns {Object|null} Reporte actualizado o null si no se encontró
 */
export function updateReport(id, updates) {
  const reports = getAll();
  const index = reports.findIndex((r) => r.id === id);
  if (index === -1) return null;
  reports[index] = { ...reports[index], ...updates };
  saveAll(reports);
  return reports[index];
}

/**
 * Elimina un reporte por ID.
 * @param {number} id - ID del reporte
 * @returns {boolean} true si se eliminó, false si no se encontró
 */
export function deleteReport(id) {
  const reports = getAll();
  const filtered = reports.filter((r) => r.id !== id);
  if (filtered.length === reports.length) return false;
  saveAll(filtered);
  return true;
}
